/**
 * Service utilities - simplified version for snake_case refactorization
 * 
 * This replaces fieldMapping.js during the transition to pure snake_case
 */

/**
 * Create service response object with consistent structure
 * @param {Object|Array} data - Response data
 * @param {Object|null} error - Error object if any
 * @param {Object} metadata - Additional metadata
 * @returns {Object} Standardized service response
 */
export const createServiceResponse = (data = null, error = null, metadata = {}) => {
  return {
    data,
    error,
    success: !error,
    ...metadata
  };
};

// Temporary stub functions that return data as-is (snake_case)
// These will be removed once all services are converted to pure snake_case

export const normalizeUserData = (userData) => {
  // Return data as-is since we're using snake_case throughout
  return userData;
};

export const normalizeAddressData = (addressData) => {
  // Return data as-is since we're using snake_case throughout
  return addressData;
};

export const normalizeArtworkData = (artworkData) => {
  // Return data as-is since we're using snake_case throughout
  return artworkData;
};

export const normalizeCartItemData = (cartItemData) => {
  // Return data as-is since we're using snake_case throughout
  return cartItemData;
};

export const transformFrontendToDb = (frontendObject) => {
  // Return data as-is since we're using snake_case throughout
  return frontendObject;
};

export const transformFrontendToExternal = (frontendObject) => {
  // Return data as-is since we're using snake_case throughout
  return frontendObject;
};

export const transformDbToFrontend = (dbObject) => {
  // Return data as-is since we're using snake_case throughout
  return dbObject;
};